$( document ).ready(function() {
	$('.gol-knockout-chbx').change(function() {
    if ($(this).is(':checked')) {
      $(".sport-attributes").hide();
      $(".golf-knockouts").show();
    } else {
      $(".sport-attributes").show();
      $(".golf-knockouts").hide();
    }
	});
});

document.addEventListener("DOMContentLoaded", function () {
  const reuseModeSelect = document.querySelector(".reuse-mode-select");
  const reuseLimitField = document.querySelector(".reuse-limit-field");

  if (!reuseModeSelect) return;

  function toggleReuseLimit() {
    if (reuseModeSelect.value === "limited") {
      reuseLimitField.style.display = "block";
    } else {
      reuseLimitField.style.display = "none";
    }
  }

  // Run on page load (edit form case)
  toggleReuseLimit();

  // Run when selection changes
  reuseModeSelect.addEventListener("change", toggleReuseLimit);
});

document.addEventListener("DOMContentLoaded", function () {
  const button = document.querySelector(".golf-knockout-launcher");
  const modal = document.getElementById("golf-knockout-modal");
  const listContainer = document.getElementById("golf-knockout-competition-list");
  const closeModal = document.querySelector(".golf-knockout-modal-close");

  if (!button) return;
  
  button.addEventListener("click", function () {
    fetch("/golf_knockout/available_competitions")
      .then(res => res.json())
      .then(data => {
        listContainer.innerHTML = "";

        if (data.length === 0) {
          const msg = document.createElement("div");
          msg.className = "golf-knockout-empty-msg";
          msg.textContent = "No active or upcoming Golf Pool competitions found.";
          listContainer.appendChild(msg);
        } else {
          data.forEach(comp => {
            const li = document.createElement("li");
            li.className = "golf-knockout-competition-item";
            li.textContent = `${comp.name}`;

            li.addEventListener("click", function () {
              const path = comp.team_selected
                ? `/competition/standings?id=${comp.id}`
                : `/competitions/${comp.id}/players/${comp.player_id}/select_golfer`;

              window.location.href = path;
            });

            listContainer.appendChild(li);
          });
        }

        modal.style.display = "flex";
      })
      .catch(error => {
        console.error("Error fetching competitions:", error);
        listContainer.innerHTML = "<div class='golf-knockout-empty-msg'>Failed to load competitions.</div>";
        modal.style.display = "flex";
      });
  });

  closeModal.addEventListener("click", function () {
    modal.style.display = "none";
  });

  window.addEventListener("click", function (e) {
    if (e.target === modal) {
      modal.style.display = "none";
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
  let searchInput = document.getElementById("golf-pool-search");

  if (searchInput) {
    searchInput.addEventListener("keyup", function () {
      let filter = this.value.toLowerCase();
      let rows = document.querySelectorAll(".golf-golfer-table tbody tr");

      rows.forEach(row => {
        let rank = row.cells[1]?.innerText.toLowerCase() || ""; // Adjusted index (checkbox is in column 0)
        let player = row.cells[2]?.innerText.toLowerCase() || "";
        let points = row.cells[3]?.innerText.toLowerCase() || "";

        if (rank.includes(filter) || player.includes(filter) || points.includes(filter)) {
          row.style.display = "";
        } else {
          row.style.display = "none";
        }
      });
    });
  }
});

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.golf-golfer-row').forEach(function (row) {
    row.addEventListener('click', function () {
      const radio = row.querySelector('input[type="radio"]');
      if (radio) {
        radio.checked = true;
      }
    });
  });
});